if (!customElements.get('keen-slider')) {
    customElements.define(
      'keen-slider',
      class Slider extends HTMLElement {
        constructor() {
          super();
  
          this.slider = this;
          this.sliderObject = null;
          this.config = JSON.parse(this.getAttribute('data-slider'));
          this.config.created = () => {
            var self = this;
            setTimeout(function(){
              window.dispatchEvent(new CustomEvent('sliderIsCreated', {
                detail: { section: self.config.id },
                bubbles: true,
                cancelable: true,
                composed: false}));
            }, 2000);
          };
          this.config.slideChanged = () => {
            var self = this;
            window.dispatchEvent(new CustomEvent('sliderChanged', {
              detail: { section: self.config.id, slider: this.slider },
              bubbles: true,
              cancelable: true,
              composed: false}));
          };
          if (!this.slider) return;
  
          var isMobile = false; //initiate as false
          // device detection
          if (
            /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(
              navigator.userAgent,
            ) ||
            /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(
              navigator.userAgent.substr(0, 4),
            )
          ) {
            isMobile = true;
          }
  
          if (window.innerWidth < 1024) {
            isMobile = true;
          }
  
          if (this.config.onlyMobile && isMobile) {
            this.initSlider();
          } else if (!this.config.onlyMobile) {
            this.initSlider();
          }
  
          window.addEventListener('sliderChanged', function (e) {
            if (e.detail.section == 'multiple-products') {
              if(!isMobile) {
                if (
                  document.querySelector('.arrow--left') != undefined &&
                  document.querySelectorAll('.arrow--left').length > 0) {
                  e.detail.slider.parentElement.querySelector('.arrow--left').style.display = "block";
                }
                if((e.detail.slider.sliderObject.track.details.maxIdx - e.detail.slider.sliderObject.track.details.rel) == 2) {
                  e.detail.slider.parentElement.querySelector('.arrow--right').style.display = "none";
                } else {
                  e.detail.slider.parentElement.querySelector('.arrow--right').style.display = "block";
                }
                if (e.detail.slider.sliderObject.track.details.rel == 0) {
                  e.detail.slider.parentElement.querySelector('.arrow--left').style.display = "none";
                }
              }
            }
          });
  
        }
  
        initSlider() {
          this.sliderObject = new KeenSlider(this.slider, this.config, [
            this.config.autoPlay ? this.autoPlay(this.sliderObject) : '',
            this.config.wheelControls ? this.wheelControls(this.sliderObject) : '',
            this.config.dots || this.config.prevNextButtons
              ? this.navigation(this.sliderObject)
              : '',
            this.config.hasThumbnails
              ? this.thumbnailsInit(
                  this.sliderObject,
                  JSON.parse(this.slider.getAttribute('data-slider-thumbnails')),
                )
              : '',
          ]);
        }
  
        autoPlay(main) {
          return (slider) => {
            let timeout;
            let mouseOver = false;
            function clearNextTimeout() {
              clearTimeout(timeout);
            }
            function nextTimeout() {
              clearTimeout(timeout);
              if (mouseOver) return;
              timeout = setTimeout(() => {
                slider.next();
              }, 4000);
            }
            slider.on('created', () => {
              slider.container.addEventListener('mouseover', () => {
                mouseOver = true;
                clearNextTimeout();
              });
              slider.container.addEventListener('mouseout', () => {
                mouseOver = false;
                nextTimeout();
              });
              nextTimeout();
            });
            slider.on('dragStarted', clearNextTimeout);
            slider.on('animationEnded', nextTimeout);
            slider.on('updated', nextTimeout);
          };
        }

        wheelControls(main) {
          return (slider) => {
            var touchTimeout;
            var position;
            var wheelActive;
    
            function dispatch(e, name) {
              position.x -= e.deltaX;
              position.y -= e.deltaY;
              slider.container.dispatchEvent(
                new CustomEvent(name, {
                  detail: {
                    x: position.x,
                    y: position.y
                  }
                })
              );
            }
    
            function wheelStart(e) {
              position = {
                x: e.pageX,
                y: e.pageY
              };
              dispatch(e, "ksDragStart");
            }
    
            function wheel(e) {
              dispatch(e, "ksDrag");
            }
    
            function wheelEnd(e) {
              dispatch(e, "ksDragEnd");
            }
    
            function eventWheel(e) {
              e.preventDefault();
              if (!wheelActive) {
                wheelStart(e);
                wheelActive = true;
              }
              wheel(e);
              clearTimeout(touchTimeout);
              touchTimeout = setTimeout(() => {
                wheelActive = false;
                wheelEnd(e);
              }, 50);
            }

            slider.container.addEventListener("wheel", eventWheel, {
              passive: false
            });
          };
        }
  
        navigation(main) {
          return (slider) => {
            let wrapper, dots, arrowLeft, arrowRight;
  
            function markup(remove) {
              wrapperMarkup(remove);
              dotMarkup(remove);
              arrowMarkup(remove);
            }
  
            function removeElement(elment) {
              elment.parentNode.removeChild(elment);
            }
            function createDiv(className) {
              var div = document.createElement('div');
              var classNames = className.split(' ');
              classNames.forEach((name) => div.classList.add(name));
              return div;
            }
  
            function arrowMarkup(remove) {
              if (remove) {
                removeElement(arrowLeft);
                removeElement(arrowRight);
                return;
              }
              arrowLeft = createDiv('arrow arrow--left');
              arrowLeft.addEventListener('click', () => slider.prev());
              arrowRight = createDiv('arrow arrow--right');
              arrowRight.addEventListener('click', () => slider.next());
  
              wrapper.appendChild(arrowLeft);
              wrapper.appendChild(arrowRight);
            }
  
            function wrapperMarkup(remove) {
              if (remove) {
                var parent = wrapper.parentNode;
                while (wrapper.firstChild)
                  parent.insertBefore(wrapper.firstChild, wrapper);
                removeElement(wrapper);
                return;
              }
              wrapper = createDiv('navigation-wrapper');
              slider.container.parentNode.appendChild(wrapper);
              wrapper.appendChild(slider.container);
            }
  
            function dotMarkup(remove) {
              if (remove) {
                removeElement(dots);
                return;
              }
              dots = createDiv('dots');
              slider.track.details.slides.forEach((_e, idx) => {
                var dot = createDiv('dot');
                dot.addEventListener('click', () => slider.moveToIdx(idx));
                dots.appendChild(dot);
              });
              wrapper.appendChild(dots);
            }
  
            function updateClasses() {
              var slide = slider.track.details.rel;
              slide === 0
                ? arrowLeft.classList.add('arrow--disabled')
                : arrowLeft.classList.remove('arrow--disabled');
              slide === slider.track.details.slides.length - 1
                ? arrowRight.classList.add('arrow--disabled')
                : arrowRight.classList.remove('arrow--disabled');
              Array.from(dots.children).forEach(function (dot, idx) {
                idx === slide
                  ? dot.classList.add('dot--active')
                  : dot.classList.remove('dot--active');
              });
            }
  
            slider.on('created', () => {
              markup();
              updateClasses();
            });
            slider.on('optionsChanged', () => {
              // console.log(2);
              markup(true);
              markup();
              updateClasses();
            });
            slider.on('slideChanged', () => {
              updateClasses();
            });
            slider.on('destroyed', () => {
              markup(true);
            });
          };
        }
  
        thumbnailsInit(main, config) {
          return (main) => {
            var thumbnails = new KeenSlider(
              config.slider_thumbnails_id,
              {
                initial: 0,
                drag: false,
                slides: {
                  perView: 4,
                  spacing: 0,
                },
                vertical: true,
              },
              [this.thumbnails(main)],
            );
          };
        }
  
        thumbnails(main) {
          return (slider) => {
            function removeActive() {
              slider.slides.forEach((slide) => {
                slide.classList.remove('active');
              });
            }
            function addActive(idx) {
              slider.slides[idx].classList.add('active');
            }
  
            function addClickEvents() {
              slider.slides.forEach((slide, idx) => {
                slide.addEventListener('click', () => {
                  main.moveToIdx(idx);
                });
              });
            }
  
            slider.on('created', () => {
              addActive(slider.track.details.rel);
              addClickEvents();
              main.on('animationStarted', (main) => {
                removeActive();
                const next = main.animator.targetIdx || 0;
                addActive(main.track.absToRel(next));
                slider.moveToIdx(next);
              });
              // fix thumbnails bug
              setTimeout(function () {
                window.dispatchEvent(new Event('resize'));
              }, 0);
            });
          };
        }
      },
    );
  }